(function(){
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
  }
  const mainProductForm = document.querySelector("product-form.product-form form.shopify-product-form");

  waitForElm('.rc_widget .rc-selling-plans select.rc_widget__option__plans__dropdown').then((elm) => {
    const subscriptionOption =
      elm.querySelector('option[value*="sub"]') ||
      elm.querySelector('option[value*="save"]') ||
      elm.querySelector("option:nth-child(2)");

    if (subscriptionOption) {
      subscriptionOption.selected = true;
      elm.dispatchEvent(new Event('change', { bubbles: true }));
    }
    setTimeout(function(){
    waitForElm('.rc-option--subsave .rc_widget__option__label').then((subscribeLabelWrap) => {
      if (subscribeLabelWrap && !document.querySelector('.glove-club-text')) {
        const infoContainer = document.createElement('div');
        infoContainer.className = 'glove-club-text';
        infoContainer.style.marginTop = '10px';
        infoContainer.style.fontSize = '13px';
        infoContainer.style.lineHeight = '1.4';
        infoContainer.style.color = '#fff';
        infoContainer.style.opacity = '0.9';

        infoContainer.innerHTML = `
          <strong style="display:block;margin-bottom:5px;">Join the Glove Club:</strong>
          <ul style="padding-left: 18px; list-style: disc; margin: 0;">
            <li>Always 25% off.</li>
            <li>Early access to new glove drops.</li>
            <li>Free shipping—even on accessory add ons.</li>
            <li>Gift on every 3rd recurring order.</li>
            <li>Pause, skip, or cancel anytime—no hard feelings.</li>
          </ul>
        `;

        subscribeLabelWrap.appendChild(infoContainer);
      }
    });

document.querySelectorAll('.single_case').forEach(function(caseEl) {
  const originalDisplayText = caseEl.querySelector('.single_case_txt p')?.innerHTML;
  if (!originalDisplayText) return;

  const regex = /\$(\d+(\.\d+)?)/g;
  const prices = [...originalDisplayText.matchAll(regex)];
  if (prices.length < 2) return;

  const originalPrice = parseFloat(prices[0][1]);
  const correctedPrice = (originalPrice * 0.6).toFixed(2);

  const priceTextEl = caseEl.querySelector('.single_case_txt p');
  if (priceTextEl) {
    priceTextEl.innerHTML = originalDisplayText.replace(prices[1][0], `$${correctedPrice}`);
  }

  caseEl.setAttribute('data-price', correctedPrice);
});

    function getElement(element){
      return document.querySelector(element);
    }

    function convertToShopifyPrice(price) {
    const numericPrice = parseFloat(price);

    if (isNaN(numericPrice)) {
      return "Invalid price";
    }

    const formattedPrice = numericPrice.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });

    return formattedPrice;
  }

    const allRcOptions = document.querySelectorAll(".rc-template__button-group .rc-radio.rc_widget__option input");
    const activeButton = getElement(".rc-template__button-group .rc-radio.rc-option--active input");
    const cartButton = mainProductForm?.querySelector("button[name='add']");
    if (!cartButton) return;
    const cartButtonText = cartButton.getAttribute("data-add-text") || cartButton.innerText;
    const saveElement = document.createElement("span");
    saveElement.classList.add('savePrice');

    if(activeButton && activeButton.value == "subsave"){
      changeButton("Subscribe now",true);
    }

    function changeButton(buttonText,saveAvailable){
      if(!cartButton.hasAttribute('disabled')){
        cartButton.innerText = buttonText;
      }
      if(saveAvailable){
        const subTotalText = getElement(".rc-option__subsave span[data-price-subsave]")?.innerText.replace("$","");
        let subTotalPrice = Number(subTotalText);
        if(subTotalPrice){
          const activeCaseValue = document.querySelector(".single_case.active")?.getAttribute("data-price");
          if(activeCaseValue){
            subTotalPrice = subTotalPrice + Number(activeCaseValue);
          }
          saveElement.innerText = convertToShopifyPrice(subTotalPrice);
        }
        cartButton.insertAdjacentElement('beforeend',saveElement);
      }else{
        cartButton.querySelector('.savePrice')?.remove();
      }
    }

    if(allRcOptions.length > 0){
      allRcOptions.forEach(function(e){
        e.addEventListener("change",function(){
          if(this.value == "subsave"){
            changeButton("Subscribe now",true);
          }else{
            changeButton(cartButtonText,false);
          }
        });
      })
    }

    function updateSubscribeButtonPrice() {
      changeButton('Subscribe now', true);
    }

    function clearCaseSelection(caseSelectionEl) {
      if (!caseSelectionEl) return;
      caseSelectionEl.querySelectorAll('.single_case.active').forEach(el => el.classList.remove('active'));
      caseSelectionEl.querySelectorAll('.btn-box.active').forEach(el => el.classList.remove('active'));
    }

    function setCaseActiveFromButton(btnEl) {
      const casbox = btnEl.closest('.casbox');
      const caseSelectionEl = btnEl.closest('.case_selection');
      if (!casbox || !caseSelectionEl) return;

      clearCaseSelection(caseSelectionEl);
      casbox.querySelector('.single_case')?.classList.add('active');
      btnEl.classList.add('active');
      updateSubscribeButtonPrice();
    }

    function setCaseActiveFromCard(cardEl) {
      const casbox = cardEl.closest('.casbox');
      const caseSelectionEl = cardEl.closest('.case_selection');
      if (!casbox || !caseSelectionEl) return;

      clearCaseSelection(caseSelectionEl);
      cardEl.classList.add('active');
      casbox.querySelector('.btn-box')?.classList.add('active');
      updateSubscribeButtonPrice();
    }

    function toggleOffCase(cardOrBtnEl) {
      const caseSelectionEl = cardOrBtnEl.closest('.case_selection');
      clearCaseSelection(caseSelectionEl);
      updateSubscribeButtonPrice();
    }

    if (!window.__RRG_CASE_TOGGLE_BOUND__) {
      window.__RRG_CASE_TOGGLE_BOUND__ = true;

      document.addEventListener('click', function (evt) {
        const target = evt.target;

        const caseSelectionEl = target.closest('.case_selection');
        if (!caseSelectionEl) return;

        const btn = target.closest('.btn-box');
        if (btn && btn.closest('.case_selection') === caseSelectionEl) {
          const wasActive = btn.classList.contains('active') || btn.closest('.casbox')?.querySelector('.single_case')?.classList.contains('active');

          if (wasActive) {
            clearCaseSelection(caseSelectionEl);
          } else {
            setCaseActiveFromButton(btn);
          }

          updateSubscribeButtonPrice();

          evt.preventDefault();
          evt.stopPropagation();
          if (typeof evt.stopImmediatePropagation === 'function') evt.stopImmediatePropagation();
          return;
        }

        const card = target.closest('.single_case');
        if (card && card.closest('.case_selection') === caseSelectionEl) {
          const wasActive = card.classList.contains('active');

          if (wasActive) {
            clearCaseSelection(caseSelectionEl);
          } else {
            setCaseActiveFromCard(card);
          }

          updateSubscribeButtonPrice();

          evt.preventDefault();
          evt.stopPropagation();
          if (typeof evt.stopImmediatePropagation === 'function') evt.stopImmediatePropagation();
          return;
        }
      }, true);
    }
    const gift_products = document.querySelectorAll(".gift-imges .variantImage");
    if(gift_products.length > 0){
      gift_products.forEach(function(e){
        e.addEventListener("click",function(){
          this.closest(".gift-imges").querySelector(".variantImage.active")?.classList.remove("active");
          this.classList.add("active");
        })
      })
    }

    },1200);
  });

if (sessionStorage.getItem("bundleToken") != null) {
  var token=sessionStorage.getItem("bundleToken");
  $.getJSON('/cart.js', function(cart) {
    if (!cart || !cart.token || cart.token !== token) {
      sessionStorage.removeItem('bundleToken');
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      data: {
        token: token
      },
      dataType: 'json',
      success: function(response) {

        sessionStorage.removeItem('bundleToken');
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.querySelector("#cart-icon-bubble .cart-count-bubble")?.remove();
      }
    });
  });
}
  const giftBox = document.querySelector(".gift_compartment_box");
  if(giftBox){
    waitForElm('.rc-widget .rc-radio-group__options input.rc-radio__input').then((elm) => {
      const radioTrigger = document.querySelectorAll(".rc-widget .rc-radio-group__options input.rc-radio__input");
      if(radioTrigger.length > 0){
        function checkValue(){
          const selectedValue = document.querySelector(".rc-widget .rc-radio-group__options input.rc-radio__input:checked");
          if (!selectedValue) {
            giftBox.classList.remove("active");
            return;
          }
          const selectedInputValue = selectedValue.value;
          if(selectedInputValue == "subsave"){
            giftBox.classList.add("active");
          }
          else{
            giftBox.classList.remove("active");
          }
        }
        checkValue();
        radioTrigger.forEach(function(e){
          e.addEventListener("change",function(){
            checkValue();
          })
        })
      }

    });

  }

  let subscription_selected = false;
  let pending_extra_items = [];
  let subscription_flow_pending = false;
  const actionForm = mainProductForm;

  function getActionTrigger() {
    return actionForm?.querySelector("button[name='add']");
  }

  function setActionTriggerBusy(isBusy) {
    const trigger = getActionTrigger();
    if (!trigger) return;

    trigger.disabled = !!isBusy;
    trigger.style.pointerEvents = isBusy ? "none" : "unset";
    trigger.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  function isRechargeSubSelected() {
    const radio = document.querySelector(".rc-widget .rc-radio-group__options input.rc-radio__input:checked");
    return radio && radio.value === "subsave";
  }

  function collectExtraItems() {
    const items = [];

    const giftContainer = document.querySelector(".sec_1_right_item3 .gift_container .variantImage.active");
    if (giftContainer && giftContainer.getAttribute("data-variant")) {
      items.push({ id: Number(giftContainer.getAttribute("data-variant")), quantity: 1 });
    }

    const activeCase = document.querySelector(".case_selection .single_case.active");
    if (activeCase && activeCase.getAttribute("data-variant")) {
      items.push({ id: Number(activeCase.getAttribute("data-variant")), quantity: 1 });
    }

    return items;
  }

  if (actionForm) {
    actionForm.addEventListener('submit', function () {
      subscription_selected = isRechargeSubSelected();
      pending_extra_items = subscription_selected ? collectExtraItems() : [];
      subscription_flow_pending = subscription_selected;
      setActionTriggerBusy(subscription_selected);
    });
  }
  document.addEventListener('ajaxProduct:added', async function () {
    if (!subscription_flow_pending) return;

    try {
      if (subscription_selected) {
        document.body.classList.add("bodyDisabled");

        if (pending_extra_items.length && window.RRGCart && typeof window.RRGCart.addItems === 'function') {
          await window.RRGCart.addItems(pending_extra_items, { sections: true, openDrawer: false });
        }

        setTimeout(function () {
          jQuery.getJSON('/cart.js', function (cart) {
            sessionStorage.setItem("bundleToken", cart.token);
            location.href = "/checkout";
          });
        }, 600);
      } else {
        setActionTriggerBusy(false);
      }
    } catch (e) {
      console.error('[RRG] Subscription flow error', e);
      setActionTriggerBusy(false);
      document.body.classList.remove("bodyDisabled");
    } finally {
      subscription_flow_pending = false;
      subscription_selected = false;
      pending_extra_items = [];
    }
  });

})();
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.product-3d-button');
  const modal = document.querySelector('.product-3d-modal');

  if (btn && modal) {
    const spinUrl = btn.getAttribute('data-spin');
    const viewer = modal.querySelector('.product-3d-viewer');

    viewer.innerHTML = `<div class="Sirv" data-src="${spinUrl}"></div>`;
    modal.hidden = false;

    if (window.Sirv && typeof window.Sirv.start === 'function') {
      window.Sirv.start();
    }
    return;
  }

  if (modal && (e.target.closest('[data-3d-close]'))) {
    modal.hidden = true;
    const viewer = modal.querySelector('.product-3d-viewer');
    if (viewer) viewer.innerHTML = '';
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  const modal = document.querySelector('.product-3d-modal');
  if (modal && !modal.hidden) {
    modal.hidden = true;
    const viewer = modal.querySelector('.product-3d-viewer');
    if (viewer) viewer.innerHTML = '';
  }
});
